import request from '@/utils/request'

// 获取团队地点库
export function GetTeamPlaceList (params) {
  return request({
    url: 'post/place/GetTeamPlaceList',
    data: params
  })
}
// 获取路线规划地点
export function GetRoutePlanNeedPlace () {
  return request({
    url: 'post/place/GetRoutePlanNeedPlace'
  })
}
// 获取团队所有地点
export function GetAllTeamPlaceList () {
  return request({
    url: 'post/place/GetAllTeamPlaceList'
  })
}
export function DeletePlace (params) {
  return request({
    url: 'post/place/DeletePlace',
    data: params
  })
}
export function BatchDeletePlace (params) {
  return request({
    url: 'post/place/BatchDeletePlace',
    data: params
  })
}
export function BatchExcelExport (params) {
  return request({
    url: 'post/place/BatchExcelExport',
    data: params
  })
}

export function UpdatePlace (params) {
  return request({
    url: 'post/place/UpdatePlace',
    data: params
  })
}
export function SavePlace (params) {
  return request({
    url: 'post/place/SavePlace',
    data: params
  })
}


export function SearchAddress(params){
  return request({
    url: 'post/place/SearchAddress',
    data: params
  })
}
export function ExcelImport (params) {
  return request({
    url: 'post/place/ExcelImport',
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/place.js